<meta http-equiv="cache-control" content="no-cache" />
<meta http-equiv="Pragma" content="no-cache" />
<meta http-equiv="Expires" content="-1" />
<meta name="viewport" content="width=device-width, initial-scale=1">
<div class="container">

    <br>

    <div class="row justify-content-center">
        <div class="col-sm-5" >
         
            <div class="">
             
              <a class="nav-link clickme" *ngIf="isShown" [ngClass]="{ 'active':activeTab==='toggleDisplayDiv'}" (click)="toggleDisplayDiv('toggleDisplayDiv')" > SSC RESULTS {{curr_year}} </a>
              
          </div>
          
        </div>
        <div class="col-sm-5" >
        
            <div class=""> 
            
            <a  class="nav-link clickme"  *ngIf="isShown"  [ngClass]="{ 'active':activeTab==='hsscResult'}" (click)="hsscResult('hsscResult')">HSSC RESULTS {{curr_year}} </a>
            
          </div>
        </div>
        <div class="col-sm-5" style="display:none">
        
          <div class=""> 
          
          <a  class="nav-link clickme"  [routerLink]="['/hsscstudents']" >ENTRANCE EXAMINATION 2021 </a>
          
        </div>
      </div>

        
      </div>
    
     
      <div *ngIf="showDiv.next" class="hsscdiv row justify-content-center" [ngClass]="{ 'active':activeTab==='hsscResult'}">
        <div class="col-sm-6 max-auto">
            <div class="card mt-3">
              <div class="card-header">
                <h5 class="card-title" >
                  <img src="/assets/board_logo.png" class="img" width="50px" height="50px">
                  <u>GBSHSE HSSC RESULT - {{curr_year}}</u>
                  <!-- <u>SSC Results</u> -->
                  </h5>
              </div>
              <div class="card-body">
               
                <form role="form" [formGroup]="selctform" (submit)="onStudentresulthssc()">
                
                    
                  <label for="staticEmail" class=" col-form-label">Seat No</label>
                
                    <div class="form-group">
                      <input id="seat"  formControlName="seat"  placeholder="SEAT NO"  class="form-control" type="text" value="" >
                        
                    </div>
                 
                 
                  <label for="staticEmail" class=" col-form-label">School Index</label>
                   
                      <div class="form-group">
                        <input id="scode"  formControlName="scode"  placeholder="SCHOOL INDEX"  class="form-control" type="text" value="">
                          
                      </div>
                  
                
                   <!-- <div class="row"></div> -->
                   
                    <!-- <label for="staticEmail" class=" col-form-label">Birth Date</label>
              
                      <div class="form-group">
                        <input id="cdtbt"  formControlName="cdtbt"  placeholder="BIRTH DATE (DD/MM) e.g. : 01/05"  class="form-control" type="text" value="" >
                          
                      </div> -->
                      <label for="staticEmail" class=" col-form-label">Registration Id</label>
                      <div class="form-group">
                        <input id="regid"  formControlName="regid"   class="form-control" type="text" value="" >
                          
                      </div>
                  
                  
                     <!--<label for="staticEmail" class="col-form-label" ><b>-------OR-------</b></label><BR>
                    <div class="row">
                    <label for="staticEmail" class=" col-form-label">Student's Name</label>
                    <div class="col-md-4">
                      <div class="form-group">
                        <input id="fname"  formControlName="fname"  placeholder="FIRST NAME"  class="form-control" type="text" value="" >
                      </div>
                    </div>
                   </div> -->
                   
                    
                    <label for="staticEmail" class=" col-form-label">Captcha</label>
                    <div class=" form-group">
                      <div>
                      <ngx-recaptcha2 #captchaElem [siteKey]="siteKey" (success)="handleSuccess($event)" [size]="size"
                      [hl]="lang" [theme]="theme" [type]="type" formControlName="recaptcha" required>
                      </ngx-recaptcha2>
                    </div>
                    </div>
                    <!-- <label for="staticEmail" class="col-sm-8 col-form-label"><b>NOTE : Exam Year Format Like MARCH 2018</b></label> -->
                  
               
                    <div class="col-md-12 form-group text-center">
                        <!-- <button type="submit" class="btn btn-primary my-4" >Get Result</button>    -->
                        <button type="submit" [disabled]="isDisabled" class="btn btn-primary">Get Result</button>
                    </div>
                   
              <br>
              
               </form>
              </div>
          </div>
      </div>
      </div>
        
    
      <div *ngIf="showDiv.previous" class="hsscdiv row justify-content-center" [ngClass]="{ 'active':activeTab==='toggleDisplayDiv'}">
        <div class="col-sm-6 max-auto">
          <div class="card mt-3">
              <div class="card-header">
                <img src="/assets/board_logo.png" class="img" width="50px" height="50px">
                <h5 class="card-title" >
                  
                  <u>GBSHSE SSC RESULT - {{curr_year}} </u>
                </h5>
              </div>
              <div class="card-body">
                  
                <form role="form" [formGroup]="sscselctform" (submit)="onStudentresultssc()">
                  
                   
                    <label for="staticEmail" class="col-form-label">Seat No</label>
                    
                      <div class="form-group">
                        <input id="seat"  formControlName="seat"  placeholder="SEAT NUMBER"  class="form-control" type="text" value="" >
                          
                      </div>
                   
                    <label for="staticEmail" class="col-form-label">School Index</label>
                    
                      <div class="form-group">
                        <input id="scode"  formControlName="scode"  placeholder="SCHOOL INDEX e.g. : 01.10"  class="form-control" type="text" value="">
                          
                      </div>
                    
                    <!-- <label for="staticEmail" class="col-form-label">Birth Date</label>
                   
                      <div class="form-group">
                        <input id="cdtbt"  formControlName="cdtbt"  placeholder="BIRTH DATE (DD/MM) e.g. : 01/05"  class="form-control" type="text" value="" >
                          
                      </div> -->

                      <label for="staticEmail" class=" col-form-label">Registration Id</label>
                      <div class="form-group">
                        <input id="regid"  formControlName="regid"   class="form-control" type="text" value="" >
                          
                      </div>
                                       
                    <!-- <label for="staticEmail" class="col-sm-2 col-form-label">Student Name</label>
                    <div class="col-md-4">
                      <div class="form-group">
                        <input id="stname"  formControlName="stname"  placeholder="STUDENT NAME"  class="form-control" type="text" value="" >
                      </div>
                    </div> -->

                    
                      <label for="staticEmail" class="col-form-label">Captcha</label>
                      <div class="form-group">
                        <ngx-recaptcha2 #captchaElem [siteKey]="siteKey" (success)="handleSuccess($event)" [size]="size"
                        [hl]="lang" [theme]="theme" [type]="type" formControlName="recaptcha" required>
                        </ngx-recaptcha2>
                      </div>
                      <!-- <label for="staticEmail" class="col-sm-2 col-form-label">{{num_one}} + {{num_two}}</label>
                      <div class="col-md-2 form-group">
                        <input id="sb1x"  formControlName="captcha"  placeholder=""  class="form-control" type="text" value="" >
                      
                      </div> -->
                      <!-- <label for="staticEmail" class="col-sm-8 col-form-label"><b>NOTE : Exam Year Format Like MARCH 2018</b></label> -->
                    
                      <div class="form-group" style="margin-top: -13px;">
                        <!-- <div class="form-group">
                            <button type="submit" [disabled]="isDisabled"class="btn btn-primary my-4" >Get Result</button>   
                          </div>  -->
                          <button type="submit" [disabled]="isDisabled_ssc" class="btn btn-primary my-4">Get Result</button> 
                          <!-- <button type="submit" class="btn btn-primary my-4">Get Result</button>  -->

                     </div>
              
                <br>
                
            </form>
              </div>
          </div>
      </div>

    </div>
    
    
    <br>

    <div *ngIf="showDiv.current;" class="hsscdiv">
      <h5 class="card-title" style="text-align: center;">
        <img src="/assets/board_logo.png" width="50px" height="50px">
        <br>
        <u>GBSHSE SSC RESULT - {{curr_year}}</u></h5>
                <br>
                <div class="card">
                  <div class="card-header card-title">
                    SSC - {{exam}}
                    <a routerLinkActive="active" [routerLink]="['/']"><img src="/assets/back.png" class="backimg" height="30px" width="50px"></a>
                    <!-- <a onclick="window.location.replace('/#/')"><img src="/assets/back.png" class="backimg" height="30px" width="50px"></a> -->
                </div>          
      <div class="row">
        <div class="col-md-12">
         
            <div class="card-body">
            
              <div class="row">
                <div class="col-md-6">
                  <h5 class="card-title">Seat No : {{seat}} </h5>
                 </div>
                <div class="col-md-6">
                  <h5 class="card-title">Name    &nbsp;&nbsp;&nbsp;&nbsp;: {{stname}}</h5>
                </div>
               
                
                <div class="col-md-6">
                  <h5 class="card-title">Father's Name &nbsp;&nbsp;: {{ftname}}</h5>
                </div>
                <div class="col-md-6">
                  <h5 class="card-title">Mother's Name &nbsp;&nbsp;: {{mtname}}</h5>
                </div>
                <h5 class="card-title col-md-8">Birth Date &nbsp;: {{cdtbt}}</h5>
              </div>
             <br>
             <table id="qualify" class="table mx-auto table-striped table-bordered table-sm row-border hover tblhssc" >
              <thead>
                <!-- <tr>
                  <th rowspan="2">Subject</th>
                  <th colspan="3">Theory</th>
                  <th colspan="3">Practical/Oral</th>
                  <th rowspan="2">Total Marks & Grade</th>
                </tr> -->
                <tr>
                  <td style="width:30%;"><b>Subject</b></td>
                  <td style="width:30px;"><b>Theory Marks<br> & Grade </b></td>
                  <td style="width:30px;"><b>Internal<br> Marks</b></td>
                  <td style="width:30px;"><b>Practical Marks<br> & Grade</b></td>
                 <td style="width:30px;"><b>Total Marks<br> & Grade</b></td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="subject">{{s1name}}</td>
                  <td>{{s1thext}} {{s1thextg}}</td>
                  <td>{{sb1pit}}</td>
                  <td>{{sb1p}} {{sb1pgr}}</td>
                  <td>{{sb1x}} {{sb1gr}}</td>
                </tr>
                <tr>
                  <td  class="subject">{{s2name}}</td>
                  <td>{{s2thext}} {{s2thextg}}</td>
                  <td>{{sb2pit}}</td>
                  <td>{{sb2p}} {{sb2pgr}}</td>
                  <td>{{sb2x}} {{sb2gr}}</td>
                </tr>
                <tr>
                  <td class="subject">{{s3name}}</td>
                  <td>{{s3thext}} {{s3thextg}}</td>
                  <td>{{sb3pit}}</td>
                  <td>{{sb3p}} {{sb3pgr}}</td>
                  <td>{{sb3x}} {{sb3gr}}</td>
                </tr>
                <tr>
                  <td  class="subject">{{s4name}}</td>
                  <td>{{s4thext}} {{s4thextg}}</td>
                  <td>{{sb4pit}}</td>
                  <td>{{sb4p}} {{sb4pgr}}</td>
                  <td>{{sb4x}} {{sb4gr}}</td>
                </tr>
                <tr>
                  <td  class="subject">{{s5name}}</td>
                  <td>{{s5thext}} {{s5thextg}}</td>
                  <td>{{sb5pit}}</td>
                  <td>{{sb5p}} {{sb5pgr}}</td>
                  <td>{{sb5x}} {{sb5gr}}</td>
                </tr>
                <tr>
                  <td  class="subject">{{s6name}}</td>
                  <td>{{s6thext}} {{s6thextg}}</td>
                  <td>{{sb6pit}}</td>
                  <td>{{sb6p}} {{sb6pgr}}</td>
                  <td>{{sb6x}} {{sb6gr}}</td>
                </tr>
                <tr>
                  <td  class="subject">{{s7name}}</td>
                  <td>{{s7thext}} {{s7thextg}}</td>
                  <td>{{sb7pit}}</td>
                  <td>{{sb7p}} {{sb7pgr}}</td>
                  <td>{{sb7x}} {{sb7gr}}</td>
                </tr>
                <tr>
                  <td colspan="3"  class="subject">Result</td>
                  <td>{{result}}</td>
                  <td>{{ttl}}</td>
                </tr>
              </tbody>
          </table>
          <h5 class="card-title">
            Note :- The results published on net are for immediate information to the examinees. These cannot be treated as original mark sheets.
            <br> Original mark sheets are to be issued by the Board separately.</h5>
            
            </div>
          </div>
            
        </div>
        <br>
    </div>
    <br>
    </div>
    <div *ngIf="showDiv.hsscrslt;">
      <h5 class="card-title" style="text-align: center;">
        <img src="/assets/board_logo.png" class="img" width="50px" height="50px">
        <br>
        <u>GBSHSE HSSC RESULT - {{curr_year}}</u></h5>
                <br>
                <div class="card">
                  <div class="card-header card-title">
                    HSSC - {{exam}}
                    <!-- <a onclick="window.location.replace('/#/')"><img src="/assets/back.png" class="backimg" height="30px" width="50px"></a> -->
                    <a routerLinkActive="active" [routerLink]="['/']"><img src="/assets/back.png" class="backimg" height="30px" width="50px"></a>
                </div>          
      <div class="row">
        <div class="col-md-12">
         
            <div class="card-body">
            
              <div class="row">
                <div class="col-md-6">
                  <h5 class="card-title">Seat No : {{seat}} </h5>
                 </div>
                <div class="col-md-6">
                  <h5 class="card-title">Name    &nbsp;&nbsp;&nbsp;&nbsp;: {{stname}}</h5>
                </div>
                
                <div class="col-md-6">
                  <h5 class="card-title" > Stream  &nbsp;&nbsp;: {{stream}}</h5>
                </div>
                <div class="col-md-6">
                  <h5 class="card-title" > Course  &nbsp;&nbsp;: {{course}}</h5>
                 </div>
                
                <div class="col-md-6">
                  <h5 class="card-title">Father's Name &nbsp;&nbsp;: {{ftname}}</h5>
                </div>
                <div class="col-md-6">
                  <h5 class="card-title">Mother's Name &nbsp;&nbsp;: {{mtname}}</h5>
                </div>
                <h5 class="card-title col-md-8">Birth Date &nbsp;: {{cdtbt}}</h5>
              </div>
             <br>
             <table id="qualify" class="table table-striped table-bordered table-sm row-border hover tblhssc" >
              <thead>
                <!-- <tr>
                  <th rowspan="2">Subject</th>
                  <th colspan="3">Theory</th>
                  <th colspan="3">Practical/Oral</th>
                  <th rowspan="2">Total Marks & Grade</th>
                </tr> -->
                <tr>
                  <td style="width:30%;"><b>Subject</b></td>
                  <td style="width:30px;"><b>Theory Marks<br> & Grade </b></td>
                  <td style="width:30px;"><b>Internal<br> Marks</b></td>
                  <td style="width:30px;"><b>Practical Marks<br> & Grade</b></td>
                 <td style="width:30px;"><b>Total Marks<br> & Grade</b></td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="subject">{{s1name}}</td>
                  <td>{{s1thext}} {{s1thextg}}</td>
                  <td>{{sb1pit}}</td>
                  <td>{{sb1p}} {{sb1pgr}}</td>
                  <td>{{sb1x}} {{sb1gr}}</td>
                </tr>
                <tr>
                  <td  class="subject">{{s2name}}</td>
                  <td>{{s2thext}} {{s2thextg}}</td>
                  <td>{{sb2pit}}</td>
                  <td>{{sb2p}} {{sb2pgr}}</td>
                  <td>{{sb2x}} {{sb2gr}}</td>
                </tr>
                <tr>
                  <td class="subject">{{s3name}}</td>
                  <td>{{s3thext}} {{s3thextg}}</td>
                  <td>{{sb3pit}}</td>
                  <td>{{sb3p}} {{sb3pgr}}</td>
                  <td>{{sb3x}} {{sb3gr}}</td>
                </tr>
                <tr>
                  <td  class="subject">{{s4name}}</td>
                  <td>{{s4thext}} {{s4thextg}}</td>
                  <td>{{sb4pit}}</td>
                  <td>{{sb4p}} {{sb4pgr}}</td>
                  <td>{{sb4x}} {{sb4gr}}</td>
                </tr>
                <tr>
                  <td  class="subject">{{s5name}}</td>
                  <td>{{s5thext}} {{s5thextg}}</td>
                  <td>{{sb5pit}}</td>
                  <td>{{sb5p}} {{sb5pgr}}</td>
                  <td>{{sb5x}} {{sb5gr}}</td>
                </tr>
                <tr>
                  <td  class="subject">{{s6name}}</td>
                  <td>{{s6thext}} {{s6thextg}}</td>
                  <td>{{sb6pit}}</td>
                  <td>{{sb6p}} {{sb6pgr}}</td>
                  <td>{{sb6x}} {{sb6gr}}</td>
                </tr>
                <tr>
                  <td  class="subject">{{s7name}}</td>
                  <td>{{s7thext}} {{s7thextg}}</td>
                  <td>{{sb7pit}}</td>
                  <td>{{sb7p}} {{sb7pgr}}</td>
                  <td>{{sb7x}} {{sb7gr}}</td>
                </tr>
                <tr>
                  <td colspan="3"  class="subject">Result</td>
                  <td>{{result}}</td>
                  <td>{{ttl}}</td>
                </tr>
              </tbody>
          </table>
          <h5 class="card-title">
            Note :- The results published on net are for immediate information to the examinees. These cannot be treated as original mark sheets.
            <br> Original mark sheets are to be issued by the Board separately.</h5>
            
            </div>
          </div>
            
        </div>
        <br>
    </div>
    <br>
    </div>
    
</div>

